const media = {
  projectVideoOne: "https://res.cloudinary.com/drj25oql8/video/upload/v1772038039/project-video-1_kvrdms.mov",
  projectVideoTwo: "https://res.cloudinary.com/drj25oql8/video/upload/v1772038793/project-video-2_jfcxtq.mov"
};

export default media;